import {
  Priority,
  registerApp,
  registerRoutingRule,
  RoutingInstruction,
} from '@mfl/framework';
import { navigationItems } from '@mfe/core-navigation';
import { currentUser } from '@mfl/platform-shell';
import {
  SURVEYS_EDIT_PERMISSION,
  SURVEYS_MVP_ENTITLEMENT,
} from '@msl/surveys-gateway-sdk';

import translations from './surveys.strings';
import { openNavUpgradeModal } from './open-nav-upgrade-modal';

const route = '/v1/surveys';

export async function register() {
  if (!currentUser.isAllowedTo(SURVEYS_EDIT_PERMISSION)) {
    return;
  }

  const entitledToSurveys = currentUser.isEntitledTo(SURVEYS_MVP_ENTITLEMENT);

  if (entitledToSurveys) {
    await registerApp('survey-management', (location) => {
      return location.pathname.startsWith(route);
    });
  }

  navigationItems.register(
    {
      key: 'SURVEYS',
      text: translations.header,
      fontAwesomeIcon: 'ballot-check',
      ...(entitledToSurveys
        ? { route }
        : {
            ornaments: [{ type: 'pro' }],
            handler: () => openNavUpgradeModal('surveys_nav'),
          }),
    },
    { priority: Priority.Medium - 108 }
  );

  if (entitledToSurveys) {
    registerRoutingRule({
      from: RoutingInstruction.ROOT,
      to: route,
      priority: Priority.High - 20,
    });
  }
}
